import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Dashboard } from './pages/Dashboard';
import { AppointmentManagement } from './pages/AppointmentManagement';
import { PatientPortal } from './pages/PatientPortal';
import { DoctorPortal } from './pages/DoctorPortal';
import { BillingPayments } from './pages/BillingPayments';
import { Pathology } from './pages/Pathology';
import { Pharmacy } from './pages/Pharmacy';
import { VendorManagement } from './pages/VendorManagement';
import { Analytics } from './pages/Analytics';
export function AppRouter() {
  return <BrowserRouter data-id="element-1">
      <Routes data-id="element-2">
        <Route path="/" element={<Dashboard data-id="element-4" />} data-id="element-3" />
        <Route path="/appointments" element={<AppointmentManagement data-id="element-6" />} data-id="element-5" />
        <Route path="/patient-portal" element={<PatientPortal data-id="element-8" />} data-id="element-7" />
        <Route path="/doctor-portal" element={<DoctorPortal data-id="element-10" />} data-id="element-9" />
        <Route path="/billing" element={<BillingPayments data-id="element-12" />} data-id="element-11" />
        <Route path="/pathology" element={<Pathology data-id="element-14" />} data-id="element-13" />
        <Route path="/pharmacy" element={<Pharmacy data-id="element-16" />} data-id="element-15" />
        <Route path="/vendors" element={<VendorManagement data-id="element-18" />} data-id="element-17" />
        <Route path="/analytics" element={<Analytics data-id="element-20" />} data-id="element-19" />
      </Routes>
    </BrowserRouter>;
}